import achievements from './Achievement/reducer';
import agreements from './Agreement/reducer';
import apiUsers from './ApiUser/reducer';
import areas from './Area/reducer';
import availableDates from './AvailableDate/reducer';
import availableDateSettings from './AvailableDateSetting/reducer';
import basicSchemaItems from './BasicSchemaItem/reducer';
import basicSchemas from './BasicSchema/reducer';
import bookingInvoiceItemAttestedDates from './BookingInvoiceItemAttestedDate/reducer';
import bookingInvoiceItemBookedDates from './BookingInvoiceItemBookedDate/reducer';
import bookingInvoiceItems from './BookingInvoiceItem/reducer';
import bookingPaymentItemAttestedDates from './BookingPaymentItemAttestedDate/reducer';
import bookingPaymentItemBookedDates from './BookingPaymentItemBookedDate/reducer';
import bookingPaymentItems from './BookingPaymentItem/reducer';
import bookingResources from './BookingResource/reducer';
import bookings from './Booking/reducer';
import budgets from './Budget/reducer';
import competencies from './Competency/reducer';
import contacts from './Contact/reducer';
import customerAgreementInvoiceSettings from './CustomerAgreementInvoiceSetting/reducer';
import customerAttestResources from './CustomerAttestResource/reducer';
import customerAttests from './CustomerAttest/reducer';
import customerBjornLundenSettings from './CustomerBjornLundenSetting/reducer';
import customerFortnoxSettings from './CustomerFortnoxSetting/reducer';
import customerLists from './CustomerList/reducer';
import customers from './Customer/reducer';
import days from './Day/reducer';
import documentTemplates from './DocumentTemplate/reducer';
import domains from './Domain/reducer';
import emails from './Email/reducer';
import employmentContractPreviews from './EmploymentContractPreview/reducer';
import employmentContracts from './EmploymentContract/reducer';
import employmentNumbers from './EmploymentNumber/reducer';
import entities from './Entity/reducer';
import entityViews from './EntityView/reducer';
import events from './Event/reducer';
import files from './File/reducer';
import geoCodes from './GeoCode/reducer';
import holidays from './Holiday/reducer';
import inquiries from './Inquiry/reducer';
import invoiceAddresses from './InvoiceAddress/reducer';
import invoiceDeliveryTypes from './InvoiceDeliveryType/reducer';
import invoiceDetails from './InvoiceDetail/reducer';
import invoices from './Invoice/reducer';
import items from './Items/reducer';
import jobBoards from './JobBoard/reducer';
import mileageAllowances from './MileageAllowance/reducer';
import municipalities from './Municipality/reducer';
import occupationNames from './OccupationName/reducer';
import oneflowCollections from './OneflowCollection/reducer';
import oneflowTemplates from './OneflowTemplate/reducer';
import paginatedItems from './PaginatedItems/reducer';
import paymentCollections from './PaymentCollection/reducer';
import paymentRows from './PaymentRow/reducer';
import payments from './Payment/reducer';
import people from './Person/reducer';
import previewBookingSmses from './PreviewBookingSms/reducer';
import pricePeriods from './PricePeriod/reducer';
import qualifyingDeductions from './QualifyingDeduction/reducer';
import questionnaire from './Questionnaire/reducer';
import recruitmentAdApplications from './RecruitmentAdApplication/reducer';
import recruitmentAdContacts from './RecruitmentAdContact/reducer';
import recruitmentAds from './RecruitmentAd/reducer';
import recruitmentStatuses from './RecruitmentStatus/reducer';
import replacementModels from './ReplacementModel/reducer';
import resourceFortnoxSettings from './ResourceFortnoxSetting/reducer';
import resourceLists from './ResourceList/reducer';
import resources from './Resource/reducer';
import services from './Service/reducer';
import session from './Session/reducer';
import signableDocuments from './SignableDocument/reducer';
import pushNotifications from './PushNotification/reducer';
import smses from './Sms/reducer';
import staffingCompanies from './StaffingCompany/reducer';
import staffingCompanyGroups from './StaffingCompanyGroup/reducer';
import staffingCompanyGroupUsages from './StaffingCompanyGroupUsage/reducer';
import statistics from './Statistic/reducer';
import tasks from './Task/reducer';
import terms from './Term/reducer';
import timeplanUnits from './TimeplanUnit/reducer';
import users from './User/reducer';
import weeklyBookings from './WeeklyBooking/reducer';
import weeklyInquiries from './WeeklyInquiry/reducer';
import WeeklyTimeReportSummary from './WeeklyTimeReportSummary/reducer';
import workTypes from './WorkType/reducer';

export default {
  achievements,
  agreements,
  apiUsers,
  areas,
  availableDates,
  availableDateSettings,
  basicSchemaItems,
  basicSchemas,
  bookingInvoiceItemAttestedDates,
  bookingInvoiceItemBookedDates,
  bookingInvoiceItems,
  bookingPaymentItemAttestedDates,
  bookingPaymentItemBookedDates,
  bookingPaymentItems,
  bookingResources,
  bookings,
  budgets,
  competencies,
  contacts,
  customerAgreementInvoiceSettings,
  customerAttestResources,
  customerAttests,
  customerBjornLundenSettings,
  customerFortnoxSettings,
  customerLists,
  customers,
  days,
  documentTemplates,
  domains,
  emails,
  employmentContractPreviews,
  employmentContracts,
  employmentNumbers,
  entities,
  entityViews,
  events,
  files,
  geoCodes,
  holidays,
  inquiries,
  invoiceAddresses,
  invoiceDeliveryTypes,
  invoiceDetails,
  invoices,
  items,
  jobBoards,
  mileageAllowances,
  municipalities,
  occupationNames,
  oneflowCollections,
  oneflowTemplates,
  paginatedItems,
  paymentCollections,
  paymentRows,
  payments,
  people,
  previewBookingSmses,
  pricePeriods,
  qualifyingDeductions,
  questionnaire,
  recruitmentAdApplications,
  recruitmentAdContacts,
  recruitmentAds,
  recruitmentStatuses,
  replacementModels,
  resourceFortnoxSettings,
  resourceLists,
  resources,
  services,
  session,
  signableDocuments,
  pushNotifications,
  smses,
  staffingCompanies,
  staffingCompanyGroups,
  staffingCompanyGroupUsages,
  statistics,
  tasks,
  terms,
  timeplanUnits,
  users,
  weeklyBookings,
  weeklyInquiries,
  WeeklyTimeReportSummary,
  workTypes,
};
